import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/poll/mocker'

export default {
  receivedPollsInfiniteLoading (searchParams) {
    if (isMock) return generator(mocker.poll())
    return instance().get(endpoint + '/poll/index', { params: searchParams })
  },
  receivedOldPollsInfiniteLoading (searchParams) {
    if (isMock) return generator(mocker.poll())
    return instance().get(endpoint + '/poll/oldPoll', { params: searchParams })
  },
  getPathImage () {
    if (isMock) return generator(mocker.pathImage())
    return instance().get(endpoint + '/poll/pathImage')
  },
  postPoll (sendParams) {
    if (isMock) return generator(mocker.savePoll())
    return instance().post(endpoint + '/poll/savePoll', sendParams)
  },
  postChoice (sendParams) {
    if (isMock) return generator(mocker.saveChoice())
    return instance().post(endpoint + '/poll/saveChoice', sendParams)
  },
  postSelectChoice (sendParams) {
    if (sendParams.p_select === 'N') {
      sendParams.p_select = 'Y'
    } else if (sendParams.p_select === 'Y') {
      sendParams.p_select = 'N'
    }
    if (isMock) return generator(mocker.saveSelectChoice())
    return instance().post(endpoint + '/poll/saveSelectChoice', sendParams)
  },
  deleteChoice (sendParams) {
    if (isMock) return generator(mocker.deleteChoice())
    let params = sendParams.codpoll + '/' + sendParams.codchoice
    return instance().delete(endpoint + '/poll/deleteChoice/' + params)
  }
}




// WEBPACK FOOTER //
// ./src/api/poll/index.js